import { Box, List, ListItem, Text } from "@simplybusiness/mobius";
import type { Recommendation } from "../../../pages/ShowcasePage/types";
import type { Action } from "../../../pages";
import { ShowcaseForm } from "../ShowcaseForm";

export interface ShowcaseExploreOptionsProps {
  recommendations: Recommendation[];
  declineAction?: Action;
}

export const ShowcaseExploreOptions = ({
  recommendations = [],
  declineAction,
}: ShowcaseExploreOptionsProps) => {
  return (
    <>
      <Text elementType="h2" className="mobius-showcase-explore__title">
        Or pick and choose your coverage
      </Text>
      <Box>
        <Text className="mobius-showcase-explore__subtitle">Select from:</Text>
        <List className="mobius-showcase-explore__list">
          {recommendations.map(recommendation => (
            <ListItem key={recommendation.productDisplayName}>
              <Text className="mobius-showcase-explore__list-item">
                {recommendation.productDisplayName}
              </Text>
            </ListItem>
          ))}
        </List>
      </Box>
      {declineAction && (
        <ShowcaseForm
          action={declineAction}
          buttonVariant="secondary"
          className="mobius-showcase-explore__form"
          buttonClassName="mobius-showcase-explore__cta"
          hiddenInputs={[{ name: "showcase_accepted", value: "false" }]}
        />
      )}
    </>
  );
};
